import { cn } from 'lib/utils';
import { RichText, Wrapper } from 'ui';

export type FootnoteProps = {
  className?: string;
  notes: string[];
};

const Footnote = ({ className, notes }: FootnoteProps) => (
  <Wrapper
    as="section"
    variant="page-full"
    className="flex justify-center pb-4"
    role="complementary"
    aria-label="Footnotes"
  >
    <div
      className={cn(
        'w-full max-w-270 border-t border-b border-neutral-200/30 py-6',
        className
      )}
    >
      <h2 className="sr-only">Footnotes</h2>
      <ul className="flex flex-col gap-2">
        {notes.map((content, index) => (
          <li key={index}>
            <RichText className="text-p3" theme="neutral" {...{ content }} />
          </li>
        ))}
      </ul>
    </div>
  </Wrapper>
);

export default Footnote;
